import type { GlobalSearchEntities } from "byzantine/src/dbbl/businessLogic/modules/search/types";

export const isSearchShortcut = (e: KeyboardEvent): boolean => {
  return e?.key?.toLowerCase() === "k" && (e.metaKey || e.ctrlKey);
};

export const getOSKeyboardShortcutText = () => {
  let shortcutText = "Ctrl K";

  if (
    typeof navigator !== "undefined" &&
    navigator?.userAgent.toLocaleLowerCase().includes("mac")
  ) {
    shortcutText = "⌘ K";
  }

  return shortcutText;
};

export const canShowSectionResults = (
  entity: GlobalSearchEntities,
  currentFilter: GlobalSearchEntities,
  entityResults: unknown[]
): boolean => ["all", entity].includes(currentFilter) && !!entityResults.length;
